import { writable, derived, get } from 'svelte/store';
import { companyInvoicesApi } from './api.js';
import { activeCompanyId } from './company.js';
import { createUnreadRefresher, shownUnread } from '../lib/read-state.js';

/** L'ultimo conteggio letto, con l'azienda a cui appartiene. */
const latestCount = writable({ companyId: null, count: 0 });

/**
 * Le fatture ricevute ancora da leggere dell'azienda attiva: una sola cifra per
 * la barra laterale e per la scheda «Ricevute», così le due non possono
 * mostrare numeri diversi. Derivata anche dall'azienda attiva: cambiando
 * azienda il numero della precedente sparisce subito, senza aspettare la
 * risposta del server.
 */
export const unreadInbound = derived([latestCount, activeCompanyId], ([latest, active]) => shownUnread(latest, active));

/**
 * Rilegge il conteggio dal server, per l'azienda attiva soltanto: le regole su
 * risposte in ritardo e aziende cambiate nel frattempo stanno in
 * createUnreadRefresher() (lib/read-state.js), dove un test può provarle.
 */
export const refreshUnread = createUnreadRefresher({
  fetchCount: (companyId) => companyInvoicesApi.getUnreadCount(companyId),
  isActive: (companyId) => get(activeCompanyId) === companyId,
  apply: (count, companyId) => latestCount.set({ companyId, count }),
});
